import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { Maybe } from "../models/generated/graphql";
import { isEmptyValue } from "../utils/is-empty-value";
import { GeneralFieldController } from "./general-field-controller";

export class RadioButtonFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return isEmptyValue(value) ? "" : `${value}`;
	}

	override useControlProps(): Maybe<FlexControlProps> | undefined {
		return {
			controlType: "radio",
		};
	}

	override mapFormValue(value: unknown): unknown {
		return isEmptyValue(value) ? null : value === "true" || value === true;
	}
}
